import { bootstrapApplication } from '@angular/platform-browser'
import { provideRouter } from '@angular/router'
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'
import { provideAppInitializer, inject, provideZoneChangeDetection } from '@angular/core'
import { provideAnimations } from '@angular/platform-browser/animations'
import { provideServiceWorker } from '@angular/service-worker'
import { isDevMode } from '@angular/core'
import { AppComponent } from './app/app.component'
import { AxiosInterceptorService } from './app/axios-interceptor.service'
import { routes } from './app/app.routes'

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    provideServiceWorker('ngsw-worker.js', { enabled: !isDevMode() }),
    AxiosInterceptorService,
    // Force AxiosInterceptorService to instantiate at startup so its
    // axios interceptors are registered before any HTTP calls are made.
    provideAppInitializer(() => {
      inject(AxiosInterceptorService)
    }),
  ],
}).catch((err) => console.error('Failed to bootstrap the application:', err))
